import { formatDate } from '@dataGrid/gridUtilities';
import TooltipContent from './components/TooltipContent';
import constants from '../../constants';

const formatToPercentage = (value) => `${value}%`;

const legendFormatter = (isPercentage) => (legendText) => {
  return `${legendText}${isPercentage ? ' (%)' : ''}`;
};

const dateFormatter = (date) => {
  return formatDate({ value: date });
};

const getFormattedGraphData = (usageData, terminalCode) => {
  return usageData?.map(({ date, selectedViewData, networkViewData }) => {
    // consider single terminal array if selected, otherwise all terminals

    const data = terminalCode ? (selectedViewData[terminalCode] ?? {}) : networkViewData;

    return {
      date,
      manuallyCreatedRoutes: data.manuallyCreatedRoutes?.count || 0,
      manuallyCreatedRoutesPercentage: data.manuallyCreatedRoutes?.percentage || 0,
      manuallyAdjustedRoutes: data.manuallyAdjustedRoutes?.count || 0,
      manuallyAdjustedRoutesPercentage: data.manuallyAdjustedRoutes?.percentage || 0
    };
  });
};

const getChartConfig = (isPercentage, theme) => {
  const colors = {
    manuallyCreatedRoutes: constants.chartColors.orange,
    manuallyAdjustedRoutes: theme.palette.primary.main
  };
  return {
    title: 'Total Manually Created and Adjusted Routes by Date',
    layout: 'vertical',
    legend: {
      verticalAlign: 'bottom',
      align: 'right',
      formatter: legendFormatter(isPercentage),
      wrapperStyle: {
        position: 'relative'
      }
    },
    yAxis: {
      tickFormatter: isPercentage ? formatToPercentage : undefined,
      domain: isPercentage ? [0, 100] : undefined,
      type: 'number',
      tick: {
        fontSize: theme.headerTextFontSize,
        fill: theme.TextColor,
        fontWeight: 600
      }
    },
    xAxis: {
      tickFormatter: dateFormatter,
      tick: {
        fontSize: theme.headerTextFontSize,
        fill: theme.TextColor,
        fontWeight: 600
      }
    },
    tooltipContent: (params) => <TooltipContent {...params} isPercentage={isPercentage} />,
    Xkey: 'date',
    YkeyList: [
      {
        dataKey: isPercentage ? 'manuallyAdjustedRoutesPercentage' : 'manuallyAdjustedRoutes',
        label: 'Manually Adjusted Routes',
        color: colors.manuallyAdjustedRoutes
      },
      {
        dataKey: isPercentage ? 'manuallyCreatedRoutesPercentage' : 'manuallyCreatedRoutes',
        label: 'Manually Created Routes',
        color: colors.manuallyCreatedRoutes
      }
    ]
  };
};

export { formatToPercentage, dateFormatter, getFormattedGraphData, legendFormatter, getChartConfig };
